import moment from 'moment';
import 'moment-timezone';

document.addEventListener('DOMContentLoaded', () => {
	function timeConvert(time, date, timezone) {
		var timestamp= moment.utc(date).valueOf();
		return moment.tz(timestamp, timezone).format('h:mm a');
	}

	const getEvents = (day, todaysEvents, dataCode, timezone, categories, cities, featured) => {
		let url = `https://${dataCode}.gnosishosting.net/Connect4/Handlers/EventListHandler.ashx?StartDate=${day}T00:00:00&EndDate=${day}T23:59:59`;
		if (featured === 'true') {
			url += '&AllPromo=1';
		}
		if (categories) {
			url += `&LimitToCategoryIDs=${categories}`;
		}
		if (cities) {
			url += `&LimitToCityIDs=${cities}`;
		}
		fetch(url)
			.then(response => response.json())
			.then(data => {
				todaysEvents.innerHTML = '';

				if(data.length === 0) {
					todaysEvents.innerHTML = '<li>No events scheduled.</li>';
				} else {
					data.forEach(element => {
						const listItem = document.createElement('li');
						const timeElement = document.createElement('strong');
						const eventNameElement = document.createElement('span');

						timeElement.textContent = timeConvert(element.EventTime, element.EventDate, timezone);
						eventNameElement.textContent = ` ${element.EventName}`;

						listItem.appendChild(timeElement);
						listItem.appendChild(eventNameElement);
						todaysEvents.appendChild(listItem);
					});
				}
			});
	}

	const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	const d = new Date();
	const year = d.getFullYear();
	const month = d.getMonth() + 1;
	const day = d.getDate();
	const today = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;

	document.querySelectorAll('.wp-block-knightowl-blocks-gnosis-calendar').forEach(calendar => {
		const todaysEvents = calendar.querySelector('.gnosis-events .todays-events');
		const dataCode = calendar.getAttribute('data-code');
		const timezone = calendar.getAttribute('data-timezone');
		const categories = calendar.getAttribute('data-categories');
		const cities = calendar.getAttribute('data-cities');
		const featured = calendar.getAttribute('data-featured');
		calendar.querySelector('.gnosis-events .month').textContent = monthNames[d.getMonth()];
		calendar.querySelector('.gnosis-events .day').textContent = `${day},`;
		calendar.querySelector('.gnosis-events .year').textContent = year;
		getEvents(today, todaysEvents, dataCode, timezone, categories, cities, featured);

		calendar.querySelectorAll('.event-calendar .calendar-date').forEach(calendarDate => {
			calendarDate.addEventListener('click', function(e) {
				e.preventDefault();
				const calendarDates = calendar.querySelectorAll('.event-calendar .calendar-date');
				calendarDates.forEach(date => date.classList.remove('active'));
				this.classList.add('active');
				calendar.querySelector('.gnosis-events .month').textContent = this.dataset.month;
				calendar.querySelector('.gnosis-events .day').textContent = `${this.dataset.day},`;
				calendar.querySelector('.gnosis-events .year').textContent = this.dataset.year;
				getEvents(this.dataset.date, todaysEvents, dataCode, timezone, categories, cities);
			});
		});
	});
});
